export default (state: any, {isSaving}: any) => ({
  ...state,
  socialMedia: {
    ...state.socialMedia,
    isSaving,
  },
});
